import Vue from 'vue';

export default {
    async getConfiguracion(parametros) {
        return Vue.axios.get("configuracion-timbres/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async guardarDatos(parametros) {
        return Vue.axios.post("cliente-datos/guardar", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async updateDatos(parametros) {
        return Vue.axios.put("cliente-datos/guardar", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async guardarPaquete(parametros) {
        return Vue.axios.post("configuracion-timbres/guardar-solicitar-paquete", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async guardarCompra(parametros) {
        return Vue.axios.post("configuracion-timbres/comprar-paquete", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async getDetalleConfiguracionTimbre(id) {
        return Vue.axios.get("configuracion-timbres/historial/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async actualizarEstatusCompra(parametros) {
        return Vue.axios.post("configuracion-timbres/aplicar-pago", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    async getUsoCFDI(parametros) {
        return Vue.axios.get("catalogo-sat/uso-cfdi/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },



    findPaquetesTimbres(parametros) {
        return Vue.axios.get("paquetes-timbres/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getPaquetesTimbres(id) {
        return Vue.axios.get("paquetes-timbres/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updatePaquetesTimbres(parametros) {
        return Vue.axios.post("paquetes-timbres/update", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    deletePaquetesTimbres(id) {
        return Vue.axios.delete("paquetes-timbres/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    storePaquetesTimbres(parametros) {
        return Vue.axios.post("paquetes-timbres", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },

    //Reporte
    reporteTimbres(parametros){
        return Vue.axios.post("reportes/reporte-timbres", parametros).then((response) => Promise.resolve(response.data)).catch((error)=> Promise.reject(error));
    }
    
}